import React from 'react'
import { Link} from "react-router-dom";
import { FormattedMessage  } from 'react-intl';

import { Breadcrumb } from 'antd';

const BreadcrumbHeader = (props) => {
    const pathSnippets = props.location.pathname.split('/').filter(i => i);
    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;

        if (index === 0)
            return null;

        let urlText = props.objectLink;
        if (props.server)
        {
            urlText += ' ' + props.server;
        }

        return (
                <Breadcrumb.Item key={props.location}>
                    <Link to={url}>{urlText}</Link>
                </Breadcrumb.Item>
                );
    });

    const breadcrumbItems = [
    <Breadcrumb.Item key={props.rootPath}>
        <Link to={props.rootPath}><FormattedMessage id={props.pathName}/></Link>
    </Breadcrumb.Item>,
    ].concat(extraBreadcrumbItems);  
    
    return (
        <div className = "breadcrumb">
            <Breadcrumb separator=':'>{breadcrumbItems}</Breadcrumb>
        </div>
    );
}

export default BreadcrumbHeader;